import { Period } from '@/ui-kit'
import { formatDatetimeToLocalTime } from '@/utils/formatDatetimeToLocalTime'
import dayjs from 'dayjs'

export function formatChartXAxisTitle(value: string, period: Period): string {
  switch (period) {
    case 'day': {
      const template = [0, 4, 8, 12, 16, 20]

      if (!template.includes(dayjs(value).get('hour'))) {
        return ''
      }

      let result = formatDatetimeToLocalTime(value)

      // Support locale date format('L') = DD/MM || MM/DD
      if (result.includes(' ')) {
        // 12h format
        if (result === '12:00 AM') {
          const date = dayjs(value).format('L').split('/')

          result = date[1] ? `${date[0]}/${date[1]}` : dayjs(value).format('MM/DD')
        }
      } else {
        // 24h format
        if (result === '00:00') {
          const datejs = dayjs(value).format('L')
          const date = datejs.includes('/') ? datejs.split('/') : datejs.split('.')

          result = date[1] ? `${date[0]}/${date[1]}` : dayjs(value).format('MM/DD')
        }
      }

      return result
    }

    case 'month':
      return dayjs(value).get('date').toString()
    case 'year':
      return (dayjs(value).get('month') + 1).toString()
    default:
      return value
  }
}
